<div class="delete-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-notification">
      Your attention is required
    </h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="py-3 text-center">
      <i class="ni ni-bell-55 ni-3x"> </i>
      <h4 class="heading mt-4">You should read this!</h4>
      <p>You are about to reactive this appointment</p>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-white" type="button" (click)="onReactiveEvent(itemId)">
      Ok, Reactive
    </button>
    <button
      class="btn btn-link text-white ml-auto"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </button>
  </div>
</div>
